import React from "react";
import EditalConvocacaoPanoramaFicFim from "../assets/docs/Edital-de-Convocacao-de-Assembleia-Geral-de-Cotistas-do-Fundo-PANORAMA-FIC-FIM-de-25-de-maio-de-2023.pdf";
import EditalConvocacaoEManifestacaoVoto from "../assets/docs/Edital-de-Convocacao-e-Manifestacao-de-Voto_11-04-2023_Captalys-Panorama-FIC-FIM-CP.pdf";
import FatoRelevanteFechamentoResgate from "../assets/docs/Fato-Relevante-Fechamento-Para-Resgate-Panorama.pdf";
import UltimoRelatorioMensal from "../assets/docs/Panorama-FIC-FIM-CP-Material-de-Divulgacao-Marco-2024.pdf";
import './fundos.css'

const Panorama = () => {
  return (
    <main id="main-container">
      <section id="secao-comunicados">
        <h2 className="text-3xl font-bold text-center">Comunicados</h2>
        <div id="container-comunicados">
          <div>
            <p><strong className="text-2xl">25 de maio de 2023</strong></p>
            <br />
            <a
              href={EditalConvocacaoPanoramaFicFim}
              target="_blank"
              rel="noreferrer"
              className="button"
            >
              Edital de Convocação - Panorama FIC FIM
            </a>
          </div>
          <div>
            <p><strong className="text-2xl">28 de março de 2023</strong></p>
            <br />
            <a
              href={EditalConvocacaoEManifestacaoVoto}
              target="_blank"
              rel="noreferrer"
              className="button"
            >
              Edital de Convocação e Manifestação de Voto
            </a>
          </div>
          <div>
            <p><strong className="text-2xl">27 de março de 2023</strong></p>
            <br />
            <a
              href={FatoRelevanteFechamentoResgate}
              target="_blank"
              rel="noreferrer"
              className="button"
            >
              Fato Relevante - Fechamento Para Resgate
            </a>
          </div>
        </div>
      </section>
      <section id="secao-rentabilidade" className="mb-8">
        <h2 className="text-3xl font-bold text-center">Rentabilidade</h2>
        <p className="text-center">Acesse aqui o último Relatório Mensal do Fundo Panorama:</p>
        <div id="container-rentabilidade">
          <div id="ultimo-relatorio">
            <strong className="text-lg">Março</strong>
            <br />
            <br />
            <a
              href={UltimoRelatorioMensal}
              target="_blank"
              rel="noreferrer"
              className="button"
              alt="Panorama - Último relatório de rentabilidade"
            >
              Clique aqui para baixar
            </a>
          </div>
        </div>
      </section>
      <section id="historico" className="mb-8">
        <h2 className="text-3xl font-bold mb-4">Histórico</h2>
        <div className="detalhes-historico">
          <details>
            <summary className="sumario">
              Histórico da gestão anterior | Período de 26 de setembro de 2016 até 16 de abril de 2023
            </summary>
            <div className="mt-4">
              <table className="w-full table">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>JAN</th>
                    <th>FEV</th>
                    <th>MAR</th>
                    <th>ABR</th>
                    <th>MAI</th>
                    <th>JUN</th>
                    <th>JUL</th>
                    <th>AGO</th>
                    <th>SET</th>
                    <th>OUT</th>
                    <th>NOV</th>
                    <th>DEZ</th>
                    <th>ANO</th>
                    <th>INÍCIO DO FUNDO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan="2">2016</td>
                    <td>Fundo</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>0.25%*</td>
                    <td>1.50%</td>
                    <td>1.48%</td>
                    <td>1.83%</td>
                    <td>5.15%</td>
                    <td>5.15%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>120%</td>
                    <td>143%</td>
                    <td>143%</td>
                    <td>163%</td>
                    <td>149%</td>
                    <td>149%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2017</td>
                    <td>Fundo</td>
                    <td>1.69%</td>
                    <td>1.43%</td>
                    <td>1.34%</td>
                    <td>1.01%</td>
                    <td>1.19%</td>
                    <td>1.08%</td>
                    <td>1.16%</td>
                    <td>1.05%</td>
                    <td>0.89%</td>
                    <td>0.87%</td>
                    <td>0.84%</td>
                    <td>0.87%</td>
                    <td>14.26%</td>
                    <td>20.15%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>156%</td>
                    <td>165%</td>
                    <td>128%</td>
                    <td>128%</td>
                    <td>129%</td>
                    <td>133%</td>
                    <td>145%</td>
                    <td>130%</td>
                    <td>138%</td>
                    <td>134%</td>
                    <td>148%</td>
                    <td>161%</td>
                    <td>143%</td>
                    <td>146%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2018</td>
                    <td>Fundo</td>
                    <td>0.94%</td>
                    <td>0.81%</td>
                    <td>0.85%</td>
                    <td>0.83%</td>
                    <td>0.81%</td>
                    <td>0.79%</td>
                    <td>0.82%</td>
                    <td>0.87%</td>
                    <td>0.69%</td>
                    <td>0.90%</td>
                    <td>0.83%</td>
                    <td>0.96%</td>
                    <td>10.58%</td>
                    <td>32.86%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>160%</td>
                    <td>173%</td>
                    <td>160%</td>
                    <td>160%</td>
                    <td>157%</td>
                    <td>153%</td>
                    <td>151%</td>
                    <td>154%</td>
                    <td>147%</td>
                    <td>165%</td>
                    <td>169%</td>
                    <td>195%</td>
                    <td>165%</td>
                    <td>156%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2019</td>
                    <td>Fundo</td>
                    <td>0.88%</td>
                    <td>0.75%</td>
                    <td>0.70%</td>
                    <td>0.84%</td>
                    <td>0.87%</td>
                    <td>0.79%</td>
                    <td>0.93%</td>
                    <td>0.77%</td>
                    <td>0.65%</td>
                    <td>0.62%</td>
                    <td>0.48%</td>
                    <td>0.61%</td>
                    <td>9.25%</td>
                    <td>45.15%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>162%</td>
                    <td>153%</td>
                    <td>150%</td>
                    <td>162%</td>
                    <td>160%</td>
                    <td>168%</td>
                    <td>163%</td>
                    <td>152%</td>
                    <td>139%</td>
                    <td>129%</td>
                    <td>127%</td>
                    <td>161%</td>
                    <td>155%</td>
                    <td>160%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2020</td>
                    <td>Fundo</td>
                    <td>0.62%</td>
                    <td>0.48%</td>
                    <td>0.56%</td>
                    <td>0.45%</td>
                    <td>0.43%</td>
                    <td>0.40%</td>
                    <td>0.45%</td>
                    <td>0.41%</td>
                    <td>0.64%</td>
                    <td>0.57%</td>
                    <td>0.42%</td>
                    <td>0.37%</td>
                    <td>5.96%</td>
                    <td>53.79%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>165%</td>
                    <td>164%</td>
                    <td>165%</td>
                    <td>159%</td>
                    <td>179%</td>
                    <td>188%</td>
                    <td>231%</td>
                    <td>255%</td>
                    <td>406%</td>
                    <td>361%</td>
                    <td>280%</td>
                    <td>234%</td>
                    <td>216%</td>
                    <td>169%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2021</td>
                    <td>Fundo</td>
                    <td>0.43%</td>
                    <td>0.29%</td>
                    <td>0.40%</td>
                    <td>0.39%</td>
                    <td>0.43%</td>
                    <td>0.48%</td>
                    <td>0.49%</td>
                    <td>0.66%</td>
                    <td>0.61%</td>
                    <td>0.59%</td>
                    <td>0.62%</td>
                    <td>0.86%</td>
                    <td>6.44%</td>
                    <td>63.70%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>289%</td>
                    <td>216%</td>
                    <td>203%</td>
                    <td>189%</td>
                    <td>161%</td>
                    <td>158%</td>
                    <td>139%</td>
                    <td>155%</td>
                    <td>138%</td>
                    <td>122%</td>
                    <td>106%</td>
                    <td>113%</td>
                    <td>147%</td>
                    <td>169%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2022</td>
                    <td>Fundo</td>
                    <td>0.81%</td>
                    <td>0.86%</td>
                    <td>1.10%</td>
                    <td>0.88%</td>
                    <td>1.10%</td>
                    <td>1.04%</td>
                    <td>1.06%</td>
                    <td>1.02%</td>
                    <td>-0.82%</td>
                    <td>0.96%</td>
                    <td>0.56%</td>
                    <td>0.33%</td>
                    <td>9.23%</td>
                    <td>78.82%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>111%</td>
                    <td>114%</td>
                    <td>119%</td>
                    <td>105%</td>
                    <td>106%</td>
                    <td>102%</td>
                    <td>103%</td>
                    <td>87%</td>
                    <td>-</td>
                    <td>94%</td>
                    <td>54%</td>
                    <td>29%</td>
                    <td>75%</td>
                    <td>144%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2023</td>
                    <td>Fundo</td>
                    <td>0.62%</td>
                    <td>0.00%</td>
                    <td>0.95%</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>1.57%</td>
                    <td>81.64%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>55%</td>
                    <td>0.00%</td>
                    <td>81%</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>48%</td>
                    <td>137%</td>
                  </tr>
                </tbody>
              </table>
              <p className="text-sm text-gray-600">
                * A rentabilidade desde o início refere-se a data de início da última gestão do Fundo, em 26/09/2016.
              </p>
            </div>
          </details>
          <details>
            <summary className="sumario">
              Histórico da gestão Polígono Capital Ltda. | A partir de 17 de abril de 2023
            </summary>
            <div className="mt-4">
              <table className="w-full text-left">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>JAN</th>
                    <th>FEV</th>
                    <th>MAR</th>
                    <th>ABR</th>
                    <th>MAI</th>
                    <th>JUN</th>
                    <th>JUL</th>
                    <th>AGO</th>
                    <th>SET</th>
                    <th>OUT</th>
                    <th>NOV</th>
                    <th>DEZ</th>
                    <th>ANO</th>
                    <th>DESDE O INÍCIO*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan="2">2023</td>
                    <td>Fundo</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-0.12%*</td>
                    <td>1.44%</td>
                    <td>1.05%</td>
                    <td>0.77%</td>
                    <td>1.87%</td>
                    <td>1.43%</td>
                    <td>1.07%</td>
                    <td>1.05%</td>
                    <td>0.97%</td>
                    <td>9.93%</td>
                    <td>9.93%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-29.40%</td>
                    <td>128.57%</td>
                    <td>98.17%</td>
                    <td>71.93%</td>
                    <td>163.70%</td>
                    <td>146.99%</td>
                    <td>107.76%</td>
                    <td>113.95%</td>
                    <td>108.43%</td>
                    <td>111.20%</td>
                    <td>111.20%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">2024</td>
                    <td>Fundo</td>
                    <td>1.10%</td>
                    <td>1.14%</td>
                    <td>1.38%</td>
                    <td>1.12%</td>
                    <td>0.31%</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>5.15%</td>
                    <td>15.59%</td>
                  </tr>
                  <tr>
                    <td>% CDI</td>
                    <td>113.48%</td>
                    <td>141.86%</td>
                    <td>165.29%</td>
                    <td>126.72%</td>
                    <td>37.43%</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>117.06%</td>
                    <td>113.62%</td>
                  </tr>
                </tbody>
              </table>
              <p className="text-sm text-gray-600">
                * A rentabilidade desde o início refere-se a data de início da gestão Polígono Capital Ltda. em 17/04/2023
              </p>
            </div>
          </details>
        </div>

      </section>
      <section id="nota" className="mb-8 container">
        <p>
          <strong>
            Em 11 de abril de 2023, a assembleia geral de cotistas do fundo Panorama Fundo de Investimento em Cotas de Fundo de Investimento Multimercado – Crédito Privado (“Fundo”) decidiu pela alteração da instituição responsável pela gestão da carteira (“Gestora”) do Fundo. Na data de 17 de abril de 2023, (i) a Polígono Capital Ltda (“Polígono”) assume o papel de Gestora do Fundo, (ii) inicia o acompanhamento e divulgação de cota diária e rentabilidade e, conforme alterado, (iii) o Fundo deixa de contar com existência de taxa de performance.
          </strong> As informações sobre rentabilidade do Fundo no período de 26 de setembro de 2016 até 16 de abril de 2023 são de responsabilidade da instituição responsável pela gestão da carteira no período mencionado e podem vir a ser utilizadas pela Polígono para fins de continuidade da série histórica. Este Material foi elaborado pela Polígono Capital Ltda., na qualidade de Gestora do Fundo, com finalidade exclusivamente informativa. A Polígono não comercializa e nem distribui cotas de fundos de investimentos. Fundos não contam com garantia do administrador do Fundo, do gestor da carteira, de qualquer mecanismo de seguro ou, ainda, do Fundo Garantidor de Crédito – FGC. Ao investidor, é recomendada a leitura cuidadosa do regulamento do Fundo ao aplicar seus recursos. Leia o prospecto e o regulamento antes de investir. A rentabilidade obtida no passado não representa garantia de rentabilidade futura e a rentabilidade divulgada não é liquida de impostos. Não há garantia de que este Fundo terá o tratamento tributário para fundos de longo prazo. O presente material não constitui oferta e/ou recomendação e/ou solicitação para subscrição ou compra de quaisquer valores mobiliários. As informações aqui contidas refletem o atual julgamento da Polígono na data de sua divulgação e estão, portanto, sujeitas a alterações sem aviso prévio. As projeções utilizam dados históricos e suposições, de forma que (i) não estão livres de erros; (ii) não é possível garantir que os cenários obtidos venham efetivamente a ocorrer; (iii) não configuram, em nenhuma hipótese, promessa ou garantia de retorno esperado nem de exposição máxima de perda; e (iv) não devem ser utilizadas para embasar nenhum procedimento administrativo perante órgãos fiscalizadores ou reguladores. A Polígono não declara ou garante, de forma expressa ou implícita, a integridade, confiabilidade ou exatidão de tais informações e se exime de qualquer responsabilidade por quaisquer prejuízos, diretos ou indiretos, que venham a decorrer da utilização desse material e de seu conteúdo. Este material apresenta informações resumidas e não é um documento completo, de modo que os investidores devem ler o regulamento e demais documentos legais do Fundo antes de investir. Os fundos de crédito privado estão sujeitos a risco de perda substancial de seu patrimônio líquido em caso de eventos que acarretem o não pagamento dos ativos integrantes de sua carteira, inclusive por força de intervenção, regime de administração temporária, falência, recuperação judicial ou extrajudicial dos emissores responsáveis pelos ativos do Fundo.
        </p>
      </section>
    </main>
  );
};

export default Panorama;
